export default "__VITE_ASSET__B7CurJI9__"